import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { WifiIcon } from 'lucide-react';
// Reusable NFC signal rings component
function NfcSignalRings({
  id
}: {
  id: string;
}) {
  return <>
      {/* Signal rings — behind shirt */}
      {[0, 1].map(i => <motion.div key={`${id}-ring-${i}`} className="absolute rounded-full pointer-events-none z-[1]" style={{
      width: 28 + i * 22,
      height: 28 + i * 22,
      top: '50%',
      left: '50%',
      marginTop: -(14 + i * 11),
      marginLeft: -(14 + i * 11),
      border: `1px solid rgba(0,180,255,${0.3 - i * 0.04})`,
      boxShadow: `0 0 ${3 + i * 1.5}px rgba(0,180,255,${0.08 - i * 0.01}), inset 0 0 ${1 + i}px rgba(0,180,255,${0.03})`
    }} animate={{
      scale: [1, 1.8 + i * 0.1],
      opacity: [0.5 - i * 0.06, 0]
    }} transition={{
      duration: 2.8 + i * 0.3,
      repeat: Infinity,
      ease: 'easeOut',
      delay: i * 0.45
    }} data-id="element-377" />)}
    </>;
}
export function ShopSection() {
  return <section className="py-10 md:py-20 bg-brand-darkest relative overflow-hidden" id="shop" data-id="element-378">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-379">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-8 md:mb-16" data-id="element-380">
          <motion.h2 initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-black mb-3" data-id="element-381">
            Choose Your Nation.{' '}
            <span className="text-gradient" data-id="element-382">Wear Your Pride.</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-gray-400 text-xs md:text-lg" data-id="element-383">
            Select from 32+ national teams. First drop limited to 5,000 units.
          </motion.p>
        </div>

        {/* Product Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 md:gap-8" data-id="element-384">
          {/* USA Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="glass-card overflow-hidden flex flex-col" data-id="element-385">
            <div className="relative h-44 sm:h-56 md:h-80 flex items-center justify-center p-3 md:p-4 overflow-hidden" style={{
            background: 'linear-gradient(160deg, #0c1220 0%, #0a1628 40%, #081430 70%, #060e1e 100%)'
          }} data-id="element-386">
              <div className="absolute inset-0 opacity-20" style={{
              backgroundImage: 'radial-gradient(circle, rgba(0,102,255,0.4) 1px, transparent 1px)',
              backgroundSize: '14px 14px'
            }} data-id="element-387" />
              <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_55%,rgba(26,42,94,0.2)_0%,rgba(0,102,255,0.08)_35%,transparent_65%)]" data-id="element-388" />
              <div className="absolute top-0 left-[10%] right-[10%] h-px bg-gradient-to-r from-transparent via-blue-400/40 to-transparent" data-id="element-389" />
              <NfcSignalRings id="us" data-id="element-390" />
              <div className="absolute top-2 right-2 md:top-4 md:right-4 z-10 bg-black/40 backdrop-blur-sm border border-brand-cyan/20 rounded-full px-2 py-1 md:px-3 md:py-1.5 flex items-center gap-1" data-id="element-391">
                <WifiIcon className="w-2.5 h-2.5 md:w-3 md:h-3 text-brand-cyan" data-id="element-392" />
                <span className="text-[8px] md:text-[10px] font-bold uppercase tracking-wider text-white" data-id="element-393">
                  NFC
                </span>
              </div>
              <div className="relative h-[95%] w-auto z-[3]" style={{
              WebkitMaskImage: 'radial-gradient(ellipse 85% 85% at 50% 50%, black 60%, transparent 100%)',
              maskImage: 'radial-gradient(ellipse 85% 85% at 50% 50%, black 60%, transparent 100%)'
            }} data-id="element-394">
                <img src="https://cdn.magicpatterns.com/uploads/2159DbvcfhqMb5pU7kuk9f/ChatGPT_Image_Mar_24,_2026,_10_52_59_AM.png" alt="USA QTAP Smart T-Shirt" loading="lazy" className="h-full w-auto object-contain select-none pointer-events-none drop-shadow-[0_0_20px_rgba(0,102,255,0.15)]" draggable={false} data-id="element-395" />
              </div>
            </div>
            <div className="p-3 md:p-6 flex-grow flex flex-col justify-between bg-brand-dark/50" data-id="element-396">
              <div className="flex justify-between items-start mb-3 md:mb-6" data-id="element-397">
                <div data-id="element-398">
                  <h3 className="text-sm md:text-xl font-heading font-bold text-white mb-0.5" data-id="element-399">
                    USA
                  </h3>
                  <p className="text-[10px] md:text-xs text-gray-400" data-id="element-400">
                    QTAP Smart T-Shirt
                  </p>
                </div>
                <div className="flex flex-col items-end" data-id="element-401">
                  <span className="text-sm md:text-lg font-heading font-bold text-brand-cyan" data-id="element-402">
                    $49.95
                  </span>
                  <span className="text-[10px] md:text-xs text-gray-500 line-through" data-id="element-403">
                    $69.95
                  </span>
                </div>
              </div>
              <a href="#pricing" className="w-full block text-center py-2 md:py-3 px-3 border border-white/20 rounded-lg text-xs md:text-sm font-bold text-white hover:bg-brand-cyan hover:border-brand-cyan transition-all duration-300" data-id="element-404">
                Order Now
              </a>
            </div>
          </motion.div>

          {/* Brazil Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.15
        }} className="glass-card overflow-hidden flex flex-col" data-id="element-405">
            <div className="relative h-44 sm:h-56 md:h-80 flex items-center justify-center p-3 md:p-4 overflow-hidden" style={{
            background: 'linear-gradient(160deg, #0c1220 0%, #0a1628 40%, #081430 70%, #060e1e 100%)'
          }} data-id="element-406">
              <div className="absolute inset-0 opacity-20" style={{
              backgroundImage: 'radial-gradient(circle, rgba(0,102,255,0.4) 1px, transparent 1px)',
              backgroundSize: '14px 14px'
            }} data-id="element-407" />
              <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_55%,rgba(200,170,0,0.15)_0%,rgba(0,102,255,0.08)_35%,transparent_65%)]" data-id="element-408" />
              <div className="absolute top-0 left-[10%] right-[10%] h-px bg-gradient-to-r from-transparent via-yellow-400/40 to-transparent" data-id="element-409" />
              <NfcSignalRings id="br" data-id="element-410" />
              <div className="absolute top-2 right-2 md:top-4 md:right-4 z-10 bg-black/40 backdrop-blur-sm border border-brand-cyan/20 rounded-full px-2 py-1 md:px-3 md:py-1.5 flex items-center gap-1" data-id="element-411">
                <WifiIcon className="w-2.5 h-2.5 md:w-3 md:h-3 text-brand-cyan" data-id="element-412" />
                <span className="text-[8px] md:text-[10px] font-bold uppercase tracking-wider text-white" data-id="element-413">
                  NFC
                </span>
              </div>
              <div className="relative h-[95%] w-auto z-[3]" style={{
              isolation: 'isolate'
            }} data-id="element-414">
                <img src="https://cdn.magicpatterns.com/uploads/sS74oHsZNYx6gwWVLnKo55/shirt_transparent_2.png" alt="Brazil QTAP Smart T-Shirt" loading="lazy" className="h-full w-auto object-contain select-none pointer-events-none" style={{
                mixBlendMode: 'screen',
                filter: 'contrast(1.15) saturate(1.25) brightness(1.05)'
              }} draggable={false} data-id="element-415" />
              </div>
            </div>
            <div className="p-3 md:p-6 flex-grow flex flex-col justify-between bg-brand-dark/50" data-id="element-416">
              <div className="flex justify-between items-start mb-3 md:mb-6" data-id="element-417">
                <div data-id="element-418">
                  <h3 className="text-sm md:text-xl font-heading font-bold text-white mb-0.5" data-id="element-419">
                    Brazil
                  </h3>
                  <p className="text-[10px] md:text-xs text-gray-400" data-id="element-420">
                    QTAP Smart T-Shirt
                  </p>
                </div>
                <div className="flex flex-col items-end" data-id="element-421">
                  <span className="text-sm md:text-lg font-heading font-bold text-brand-cyan" data-id="element-422">
                    $49.95
                  </span>
                  <span className="text-[10px] md:text-xs text-gray-500 line-through" data-id="element-423">
                    $69.95
                  </span>
                </div>
              </div>
              <a href="#pricing" className="w-full block text-center py-2 md:py-3 px-3 border border-white/20 rounded-lg text-xs md:text-sm font-bold text-white hover:bg-brand-cyan hover:border-brand-cyan transition-all duration-300" data-id="element-424">
                Order Now
              </a>
            </div>
          </motion.div>

          {/* Argentina Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="glass-card overflow-hidden flex flex-col" data-id="element-425">
            <div className="relative h-44 sm:h-56 md:h-80 flex items-center justify-center p-3 md:p-4 overflow-hidden" style={{
            background: 'linear-gradient(160deg, #0c1220 0%, #0a1628 40%, #081430 70%, #060e1e 100%)'
          }} data-id="element-426">
              <div className="absolute inset-0 opacity-20" style={{
              backgroundImage: 'radial-gradient(circle, rgba(0,102,255,0.4) 1px, transparent 1px)',
              backgroundSize: '14px 14px'
            }} data-id="element-427" />
              <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_55%,rgba(74,144,217,0.15)_0%,rgba(0,102,255,0.08)_35%,transparent_65%)]" data-id="element-428" />
              <div className="absolute top-0 left-[10%] right-[10%] h-px bg-gradient-to-r from-transparent via-sky-400/40 to-transparent" data-id="element-429" />
              <NfcSignalRings id="ar" data-id="element-430" />
              <div className="absolute top-2 right-2 md:top-4 md:right-4 z-10 bg-black/40 backdrop-blur-sm border border-brand-cyan/20 rounded-full px-2 py-1 md:px-3 md:py-1.5 flex items-center gap-1" data-id="element-431">
                <WifiIcon className="w-2.5 h-2.5 md:w-3 md:h-3 text-brand-cyan" data-id="element-432" />
                <span className="text-[8px] md:text-[10px] font-bold uppercase tracking-wider text-white" data-id="element-433">
                  NFC
                </span>
              </div>
              <div className="relative h-[95%] w-auto z-[3]" style={{
              WebkitMaskImage: 'radial-gradient(ellipse 80% 82% at 50% 48%, black 55%, transparent 100%)',
              maskImage: 'radial-gradient(ellipse 80% 82% at 50% 48%, black 55%, transparent 100%)'
            }} data-id="element-434">
                <img src="https://cdn.magicpatterns.com/uploads/9fVTjcgDH3ynZdjBWXuL2r/argentina2_transparent.png" alt="Argentina QTAP Smart T-Shirt" loading="lazy" className="h-full w-auto object-contain select-none pointer-events-none drop-shadow-[0_0_20px_rgba(0,102,255,0.15)]" draggable={false} data-id="element-435" />
              </div>
            </div>
            <div className="p-3 md:p-6 flex-grow flex flex-col justify-between bg-brand-dark/50" data-id="element-436">
              <div className="flex justify-between items-start mb-3 md:mb-6" data-id="element-437">
                <div data-id="element-438">
                  <h3 className="text-sm md:text-xl font-heading font-bold text-white mb-0.5" data-id="element-439">
                    Argentina
                  </h3>
                  <p className="text-[10px] md:text-xs text-gray-400" data-id="element-440">
                    QTAP Smart T-Shirt
                  </p>
                </div>
                <div className="flex flex-col items-end" data-id="element-441">
                  <span className="text-sm md:text-lg font-heading font-bold text-brand-cyan" data-id="element-442">
                    $49.95
                  </span>
                  <span className="text-[10px] md:text-xs text-gray-500 line-through" data-id="element-443">
                    $69.95
                  </span>
                </div>
              </div>
              <a href="#pricing" className="w-full block text-center py-2 md:py-3 px-3 border border-white/20 rounded-lg text-xs md:text-sm font-bold text-white hover:bg-brand-cyan hover:border-brand-cyan transition-all duration-300" data-id="element-444">
                Order Now
              </a>
            </div>
          </motion.div>

          {/* Colombia Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.25
        }} className="glass-card overflow-hidden flex flex-col" data-id="element-445">
            <div className="relative h-44 sm:h-56 md:h-80 flex items-center justify-center p-3 md:p-4 overflow-hidden" style={{
            background: 'linear-gradient(160deg, #0c1220 0%, #0a1628 40%, #081430 70%, #060e1e 100%)'
          }} data-id="element-446">
              <div className="absolute inset-0 opacity-20" style={{
              backgroundImage: 'radial-gradient(circle, rgba(0,102,255,0.4) 1px, transparent 1px)',
              backgroundSize: '14px 14px'
            }} data-id="element-447" />
              <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_55%,rgba(200,170,0,0.15)_0%,rgba(0,102,255,0.08)_35%,transparent_65%)]" data-id="element-448" />
              <div className="absolute top-0 left-[10%] right-[10%] h-px bg-gradient-to-r from-transparent via-yellow-400/40 to-transparent" data-id="element-449" />
              <NfcSignalRings id="co" data-id="element-450" />
              <div className="absolute top-2 right-2 md:top-4 md:right-4 z-10 bg-black/40 backdrop-blur-sm border border-brand-cyan/20 rounded-full px-2 py-1 md:px-3 md:py-1.5 flex items-center gap-1" data-id="element-451">
                <WifiIcon className="w-2.5 h-2.5 md:w-3 md:h-3 text-brand-cyan" data-id="element-452" />
                <span className="text-[8px] md:text-[10px] font-bold uppercase tracking-wider text-white" data-id="element-453">
                  NFC
                </span>
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/tbW545aM26KKUpVvZKv6am/ChatGPT_Image_Mar_23,_2026,_10_21_36_PM.png" alt="Colombia QTAP Smart T-Shirt" loading="lazy" className="h-[95%] w-auto object-contain select-none pointer-events-none relative z-[3]" style={{
              mixBlendMode: 'screen',
              filter: 'contrast(1.15) saturate(1.25) brightness(1.05)'
            }} draggable={false} data-id="element-454" />
            </div>
            <div className="p-3 md:p-6 flex-grow flex flex-col justify-between bg-brand-dark/50" data-id="element-455">
              <div className="flex justify-between items-start mb-3 md:mb-6" data-id="element-456">
                <div data-id="element-457">
                  <h3 className="text-sm md:text-xl font-heading font-bold text-white mb-0.5" data-id="element-458">
                    Colombia
                  </h3>
                  <p className="text-[10px] md:text-xs text-gray-400" data-id="element-459">
                    QTAP Smart T-Shirt
                  </p>
                </div>
                <div className="flex flex-col items-end" data-id="element-460">
                  <span className="text-sm md:text-lg font-heading font-bold text-brand-cyan" data-id="element-461">
                    $49.95
                  </span>
                  <span className="text-[10px] md:text-xs text-gray-500 line-through" data-id="element-462">
                    $69.95
                  </span>
                </div>
              </div>
              <a href="#pricing" className="w-full block text-center py-2 md:py-3 px-3 border border-white/20 rounded-lg text-xs md:text-sm font-bold text-white hover:bg-brand-cyan hover:border-brand-cyan transition-all duration-300" data-id="element-463">
                Order Now
              </a>
            </div>
          </motion.div>

          {/* Spain Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="glass-card overflow-hidden flex flex-col" data-id="element-464">
            <div className="relative h-44 sm:h-56 md:h-80 flex items-center justify-center p-3 md:p-4 overflow-hidden" style={{
            background: 'linear-gradient(160deg, #0c1220 0%, #0a1628 40%, #081430 70%, #060e1e 100%)'
          }} data-id="element-465">
              <div className="absolute inset-0 opacity-20" style={{
              backgroundImage: 'radial-gradient(circle, rgba(0,102,255,0.4) 1px, transparent 1px)',
              backgroundSize: '14px 14px'
            }} data-id="element-466" />
              <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_55%,rgba(0,102,255,0.12)_0%,rgba(0,102,255,0.06)_35%,transparent_65%)]" data-id="element-467" />
              <div className="absolute top-0 left-[10%] right-[10%] h-px bg-gradient-to-r from-transparent via-blue-400/40 to-transparent" data-id="element-468" />
              <NfcSignalRings id="es" data-id="element-469" />
              <div className="absolute top-2 right-2 md:top-4 md:right-4 z-10 bg-black/40 backdrop-blur-sm border border-brand-cyan/20 rounded-full px-2 py-1 md:px-3 md:py-1.5 flex items-center gap-1" data-id="element-470">
                <WifiIcon className="w-2.5 h-2.5 md:w-3 md:h-3 text-brand-cyan" data-id="element-471" />
                <span className="text-[8px] md:text-[10px] font-bold uppercase tracking-wider text-white" data-id="element-472">
                  NFC
                </span>
              </div>
              <div className="relative h-[95%] w-auto z-[3]" style={{
              WebkitMaskImage: 'radial-gradient(ellipse 80% 82% at 50% 48%, black 55%, transparent 100%)',
              maskImage: 'radial-gradient(ellipse 80% 82% at 50% 48%, black 55%, transparent 100%)'
            }} data-id="element-473">
                <img src="https://cdn.magicpatterns.com/uploads/15C9yMpM3TmozToLELneZy/shirt_transparent_0.png" alt="Spain QTAP Smart T-Shirt" loading="lazy" className="h-full w-auto object-contain select-none pointer-events-none drop-shadow-[0_0_20px_rgba(0,102,255,0.15)]" draggable={false} data-id="element-474" />
              </div>
            </div>
            <div className="p-3 md:p-6 flex-grow flex flex-col justify-between bg-brand-dark/50" data-id="element-475">
              <div className="flex justify-between items-start mb-3 md:mb-6" data-id="element-476">
                <div data-id="element-477">
                  <h3 className="text-sm md:text-xl font-heading font-bold text-white mb-0.5" data-id="element-478">
                    Spain
                  </h3>
                  <p className="text-[10px] md:text-xs text-gray-400" data-id="element-479">
                    QTAP Smart T-Shirt
                  </p>
                </div>
                <div className="flex flex-col items-end" data-id="element-480">
                  <span className="text-sm md:text-lg font-heading font-bold text-brand-cyan" data-id="element-481">
                    $49.95
                  </span>
                  <span className="text-[10px] md:text-xs text-gray-500 line-through" data-id="element-482">
                    $69.95
                  </span>
                </div>
              </div>
              <a href="#pricing" className="w-full block text-center py-2 md:py-3 px-3 border border-white/20 rounded-lg text-xs md:text-sm font-bold text-white hover:bg-brand-cyan hover:border-brand-cyan transition-all duration-300" data-id="element-483">
                Order Now
              </a>
            </div>
          </motion.div>

          {/* Mexico Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.35
        }} className="glass-card overflow-hidden flex flex-col" data-id="element-484">
            <div className="relative h-44 sm:h-56 md:h-80 flex items-center justify-center p-3 md:p-4 overflow-hidden" style={{
            background: 'linear-gradient(160deg, #0c1220 0%, #0a1628 40%, #081430 70%, #060e1e 100%)'
          }} data-id="element-485">
              <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_55%,rgba(26,92,42,0.2)_0%,rgba(0,102,255,0.08)_35%,transparent_65%)]" data-id="element-486" />
              <div className="absolute top-0 left-[10%] right-[10%] h-px bg-gradient-to-r from-transparent via-green-400/40 to-transparent" data-id="element-487" />
              <NfcSignalRings id="mx" data-id="element-488" />
              <div className="absolute top-2 right-2 md:top-4 md:right-4 z-10 bg-black/40 backdrop-blur-sm border border-brand-cyan/20 rounded-full px-2 py-1 md:px-3 md:py-1.5 flex items-center gap-1" data-id="element-489">
                <WifiIcon className="w-2.5 h-2.5 md:w-3 md:h-3 text-brand-cyan" data-id="element-490" />
                <span className="text-[8px] md:text-[10px] font-bold uppercase tracking-wider text-white" data-id="element-491">
                  NFC
                </span>
              </div>
              <div className="relative h-[95%] w-auto z-[3]" style={{
              isolation: 'isolate'
            }} data-id="element-492">
                <img src="https://cdn.magicpatterns.com/uploads/fywKWsm4rEgF6PWNx1tvRM/mexico_shirt_transparent.png" alt="Mexico QTAP Smart T-Shirt" loading="lazy" className="h-full w-auto object-contain select-none pointer-events-none" style={{
                mixBlendMode: 'screen',
                filter: 'contrast(1.15) saturate(1.25) brightness(1.05)'
              }} draggable={false} data-id="element-493" />
              </div>
            </div>
            <div className="p-3 md:p-6 flex-grow flex flex-col justify-between bg-brand-dark/50" data-id="element-494">
              <div className="flex justify-between items-start mb-3 md:mb-6" data-id="element-495">
                <div data-id="element-496">
                  <h3 className="text-sm md:text-xl font-heading font-bold text-white mb-0.5" data-id="element-497">
                    Mexico
                  </h3>
                  <p className="text-[10px] md:text-xs text-gray-400" data-id="element-498">
                    QTAP Smart T-Shirt
                  </p>
                </div>
                <div className="flex flex-col items-end" data-id="element-499">
                  <span className="text-sm md:text-lg font-heading font-bold text-brand-cyan" data-id="element-500">
                    $49.95
                  </span>
                  <span className="text-[10px] md:text-xs text-gray-500 line-through" data-id="element-501">
                    $69.95
                  </span>
                </div>
              </div>
              <a href="#pricing" className="w-full block text-center py-2 md:py-3 px-3 border border-white/20 rounded-lg text-xs md:text-sm font-bold text-white hover:bg-brand-cyan hover:border-brand-cyan transition-all duration-300" data-id="element-502">
                Order Now
              </a>
            </div>
          </motion.div>
        </div>

        {/* View All Link */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="text-center mt-10 md:mt-16" data-id="element-503">
          <a href="#all-teams" className="text-brand-cyan hover:text-brand-sky font-medium text-sm underline underline-offset-4 transition-colors" data-id="element-504">
            View All 32 Teams
          </a>
        </motion.div>
      </div>
    </section>;
}